import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.9375 4.8125H1.75V2.625M12.25 7C12.25 4.10025 9.89975 1.75 7 1.75C4.8825 1.75 3.06192 3.0065 2.23183 4.8125M10.0625 9.1875H12.25V11.375M1.75 7C1.75 9.89975 4.10025 12.25 7 12.25C9.1175 12.25 10.9381 10.9935 11.7682 9.1875",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgRefresh);
export default ForwardRef;
